<template>
  <div class="wrapper">
    <div>
    <CButton  color="info"   @click="openModal"><b>Add New System Rules</b></CButton>
    <CRow class="mt-3">
      <div>  
      </div>
                  <CCol xl="12">
                        <CCard>
                          <CCardBody>
                            <div>
                              <CCard class="mt-3 mb-0" v-for="item in datas.data" :key="item.id">
                                <CButton 
                                  block 
                                  color="link" 
                                  class="text-left shadow-none card-header" 
                                  @click="accordion = accordion === `${item.id}` ? false : `${item.id}`" 
                                >
                                  <h6>{{ item.target }}</h6>
                                  
                                </CButton>
                                <CCollapse :show="accordion === `${item.id}`">
                                  <CCardBody>
                                    {{ item.description }}
                                    <br><br><CButton @click="openModalEdit(item.id)" color="primary" size="sm"><b-icon icon="pencil"></b-icon></CButton>
                                    <CButton class="ml-2" @click="destroy(item.id)" color="danger" size="sm"><b-icon icon="trash"></b-icon></CButton>
                                  </CCardBody>
                                </CCollapse>
                              </CCard>
                            </div>
                          </CCardBody>
                        </CCard>
                      </CCol>
    </CRow>
      <systemrulesmodal></systemrulesmodal>
      <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables.vue'
import axios from 'axios'

import rule from '@/services/rule'
import systemrulesmodal  from './systemrulesmodal.vue';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: 'KeperluanTables',
  components: { systemrulesmodal, alertmodal, Datatable },
  data(){
    return{
      form:{
        name:'',
      },
      datas:[],
      accordion: '',
      updateSubmit: false,
      largeModal:false,
    
      items: [],

    }
    //end
  },

  created() {
      //this.loadData()
  },
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

   },
   
  methods: {
    openModal: function () {
      
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Define/edit/delete rules') !== -1){
          //IF ALLOW
      var params = {title: 'Add New System Rules', mode:'create'}
      EventBus.$emit('OPEN_MODAL_SYSTEM_RULES', params)
    //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal')
        } 
        
      }
      //SET END
    },

    openModalEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Define/edit/delete rules') !== -1){
          //IF ALLOW
      var params = {title: 'Edit System Rules', mode:'edit', data:id}
      EventBus.$emit('OPEN_MODAL_SYSTEM_RULES', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal')
        } 
        
      }
      //SET END
    },
   

    destroy(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Define/edit/delete rules') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete this Rule?")){
        rule.destroyRule(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        
      } 
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },


    loadData() {
      rule.getRule()
      .then(res => {
          //let getData = res.data
          this.datas = res
          //this.is_active = res.is_active          
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },



  }
}
</script>